import React, { useEffect, useState } from "react";
import Page from "src/components/Page";
import {
  Box,
  Button,
  Card,
  Container,
  Grid,
  IconButton,
  Modal,
  Stack,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import Select from "react-select";
import DataTable from "react-data-table-component";
import { getAllMemberTravelingListApi } from "src/api/commonapi";
import { fetchallcitylist } from "src/utils/common";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import moment from "moment";
import { List, ListAlt } from "@mui/icons-material";
import CustomLoader from "src/commonComponents/CustomLoader";

export default function Traveling() {
  let loginUser = JSON.parse(localStorage.getItem("userData"));

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [citylist, setcitylist] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [openTravelModal, setOpenTravelModal] = useState(false);
  const [selectedTravelDates, setSelectedTravelDates] = useState([]);
  const [travelingData, setTravelingData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMember, setSelectedMember] = useState("");
  const [searchCall, setSearchCall] = useState(false);
  const [searchClearCall, setSearchClearCall] = useState(false);
  const [filtereddata, setFilteredData] = useState({
    start_date: null,
    end_date: null,
    m_city_id:
      loginUser?.u_type == 1 ||
      (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
        ? loginUser?.city_id
        : 0,
    t_city_id: 0,
    searchValue: ""
  });

  const handleGetTravelingData = async (data) => {
    setIsLoading(true);
    let res = await getAllMemberTravelingListApi({
      page: currentPage,
      per_page: rowsPerPage,
      ...data
    });
    setIsLoading(false);
    if (res.status == 1) {
      setTravelingData(res?.data?.data);
      setTotalRows(res?.data.countresult);
    }
  };

  const getallcitylist = async () => {
    setcitylist(await fetchallcitylist());
  };
  useEffect(async () => {
    getallcitylist();
  }, []);

  const columns = [
    {
      name: "No",
      selector: (row, index) => totalRows - ((currentPage - 1) * rowsPerPage + index),
      width: "100px"
    },
    {
      name: "Traveling Purpose",
      wrap: true,
      selector: (row) => row?.travelling_type
    },

    {
      name: "Member Name",
      wrap: true,
      selector: (row) => row?.m_name
    },
    {
      name: "Business Name",
      wrap: true,
      selector: (row) => row?.business_name
    },
    {
      name: "Traveling City",
      wrap: true,
      selector: (row) => row?.city_name
    },
    {
      name: "Start Date",
      wrap: true,
      selector: (row) => row?.s_date
    },
    {
      name: "End Date",
      wrap: true,
      selector: (row) => row?.e_date
    },
    {
      name: "Details",
      wrap: true,
      width: "100px",
      cell: (row) => (
        <>
          <Tooltip title="View Travel Details">
            <IconButton>
              <List
                color="secondary"
                onClick={() => {
                  setSelectedTravelDates(row?.travel_dates || []);
                  setSelectedMember(row?.m_name);
                  setOpenTravelModal(true);
                }}
              />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];

  useEffect(() => {
    handleGetTravelingData(filtereddata);
  }, [currentPage, rowsPerPage]);

  return (
    <Page title="LVB Traveling | Local Vocal Business Group">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h4" gutterBottom>
            Traveling
          </Typography>
        </Stack>
        <Card className="p-20">
          <Grid container spacing={1}>
            <Grid item xs={4}>
              <Stack>
                <label>Select Member City</label>
                <Select
                  menuPortalTarget={document.body}
                  isDisabled={
                    loginUser?.u_type == 1 ||
                    (loginUser?.u_type == 2 &&
                      loginUser?.p_user_id != 1 &&
                      loginUser?.management_p == 1)
                      ? true
                      : false
                  }
                  options={[
                    {
                      value: 0,
                      label: "All City"
                    },
                    ...citylist.map((city) => {
                      return {
                        label: city?.city_name,
                        value: city?.city_id
                      };
                    })
                  ]}
                  onChange={(e) => {
                    setSearchCall(true);
                    setFilteredData({
                      ...filtereddata,
                      m_city_id: e.value
                    });
                  }}
                  value={
                    filtereddata.m_city_id == 0
                      ? {
                          value: 0,
                          label: "All City"
                        }
                      : citylist.map((city) => {
                          return (
                            filtereddata.m_city_id == city.city_id && {
                              value: city.city_id,
                              label: city.city_name
                            }
                          );
                        })
                  }
                />
              </Stack>
            </Grid>

            <Grid item xs={4}>
              <Stack>
                <label>Select Traveling City</label>
                <Select
                  menuPortalTarget={document.body}
                  isDisabled={false}
                  options={[
                    {
                      value: 0,
                      label: "All City"
                    },
                    ...citylist.map((city) => {
                      return {
                        label: city?.city_name,
                        value: city?.city_id
                      };
                    })
                  ]}
                  onChange={(e) => {
                    setSearchCall(true);
                    setFilteredData({
                      ...filtereddata,
                      t_city_id: e.value
                    });
                  }}
                  value={
                    filtereddata.t_city_id == 0
                      ? {
                          value: 0,
                          label: "All City"
                        }
                      : citylist.map((city) => {
                          return (
                            filtereddata.t_city_id == city.city_id && {
                              value: city.city_id,
                              label: city.city_name
                            }
                          );
                        })
                  }
                />
              </Stack>
            </Grid>

            <Grid item xs={4}>
              <Stack spacing={10}>
                <TextField
                  fullWidth
                  style={{ marginTop: "22px" }}
                  autoComplete="off"
                  type="text"
                  label="Search"
                  name="name"
                  size="small"
                  autoCorrect="off"
                  value={filtereddata.searchValue}
                  onChange={(e) => {
                    setSearchCall(true);
                    setFilteredData({
                      ...filtereddata,
                      searchValue: e.target.value
                    });
                  }}
                />
              </Stack>
            </Grid>

            <Grid item xs={4}>
              <Stack spacing={0}>
                <LocalizationProvider dateAdapter={AdapterDateFns} style={{ marginTop: "0px" }}>
                  <label>Start Date</label>
                  <DatePicker
                    type="date"
                    name="s_date"
                    inputFormat="dd/MM/yyyy"
                    value={
                      filtereddata.start_date != null
                        ? moment(filtereddata.start_date, "DD-MM-YYYY")
                        : null
                    }
                    onChange={(newDate) => {
                      setSearchCall(true);
                      setFilteredData({
                        ...filtereddata,
                        start_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        // onKeyDown={(e) => e.preventDefault()}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Stack>
            </Grid>

            <Grid item xs={4}>
              <Stack spacing={0}>
                <label>End Date</label>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    type="date"
                    name="e_date"
                    inputFormat="dd/MM/yyyy"
                    value={
                      filtereddata.end_date != null
                        ? moment(filtereddata.end_date, "DD-MM-YYYY")
                        : null
                    }
                    onChange={(newDate) => {
                      setSearchCall(true);
                      setFilteredData({
                        ...filtereddata,
                        end_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        // onKeyDown={(e) => e.preventDefault()}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Stack>
            </Grid>

            <Grid
              xs={2}
              item
              sx={{ display: "flex", justifyContent: "flex-end", marginTop: "15px" }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between"
                }}
              >
                <Button
                  variant="contained"
                  style={{ margin: "0 5px" }}
                  onClick={() => {
                    if (searchCall) {
                      handleGetTravelingData(filtereddata);
                      // GetV2VData(0, searchdata);
                      setSearchClearCall(true);
                    }
                  }}
                >
                  Search
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => {
                    if (searchClearCall) {
                      handleGetTravelingData({
                        start_date: null,
                        end_date: null,
                        m_city_id:
                          loginUser?.u_type == 1 ||
                          (loginUser?.u_type == 2 &&
                            loginUser?.p_user_id != 1 &&
                            loginUser?.management_p == 1)
                            ? loginUser?.city_id
                            : 0,
                        t_city_id: 0,
                        searchValue: ""
                      });
                      setFilteredData({
                        start_date: null,
                        end_date: null,
                        m_city_id:
                          loginUser?.u_type == 1 ||
                          (loginUser?.u_type == 2 &&
                            loginUser?.p_user_id != 1 &&
                            loginUser?.management_p == 1)
                            ? loginUser?.city_id
                            : 0,
                        t_city_id: 0,
                        searchValue: ""
                      });
                    }
                  }}
                >
                  Clear
                </Button>
              </div>
            </Grid>
          </Grid>
        </Card>

        <Card spacing={3} style={{ padding: "10px", marginTop: "20px" }}>
          <DataTable
            filter
            pagination
            highlightOnHover
            columns={columns}
            data={travelingData != null ? travelingData : []}
            paginationServer
            paginationTotalRows={totalRows}
            onChangePage={(p) => setCurrentPage(p)}
            onChangeRowsPerPage={(newPerPage) => setRowsPerPage(newPerPage)}
            progressPending={isLoading}
            progressComponent={<CustomLoader />}
          />
        </Card>
      </Container>

      <Modal
        open={openTravelModal}
        onClose={() => {
          setOpenTravelModal(false);
        }}
        aria-labelledby="modal-connected-block-title"
        aria-describedby="modal-connected-block-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            borderRadius: "10px",
            boxShadow: 24,
            p: 3,
            maxHeight: "80vh",
            overflowY: "auto"
          }}
        >
          <Typography variant="h6" mb={2}>
            Travel Dates – {selectedMember}
          </Typography>

          {selectedTravelDates.length > 0 ? (
            selectedTravelDates.map((item, index) => (
              <Card
                key={index}
                sx={{
                  p: 2,
                  mb: 2,
                  border: "1px solid #eee",
                  borderRadius: "8px"
                }}
              >
                <Typography fontWeight="bold">{item?.date}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {item?.detail}
                </Typography>
              </Card>
            ))
          ) : (
            <Typography>No travel dates available</Typography>
          )}

          <Button
            fullWidth
            variant="contained"
            sx={{ mt: 2 }}
            onClick={() => setOpenTravelModal(false)}
          >
            Close
          </Button>
        </Box>
      </Modal>
    </Page>
  );
}
